import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';
import PrimeTable from '../../../components/PrimeTable';
import IntOutBoundFileFilterForm from './intOutBoundFileFilterForm';

const IntOutBoundFileList = () => {

    let navigate = useNavigate();
    const dispatch = useDispatch();
    
    const intFileList = useSelector((state) => state.intOutBoundFile.intoutboundfileList);

    const intfile = useSelector((state) => state.intOutBoundFile.intoutboundfile);

    const filters = useSelector((state) => state.intOutBoundFile.filters);
    
    const defaultParams = useMemo(() => ({
        ...filters,
        pageno: 1,
        pagesize: 50,
        sort: 'createdOn',
        sortOrder: -1,
    }), [filters]);
    

    const [formValues, setFormValues] = useState(defaultParams);
    
    const handleFormValuesChange = (values) => {
        setFormValues(values);
    };

    const handleReset = () => {
        setFormValues(defaultParams)
        dispatch(appActions.INTOUTBOUNDFILE_GET_ALL_REQUEST(defaultParams));
    }

    const handleRefresh = useCallback(() => {
        dispatch(appActions.INTOUTBOUNDFILE_GET_ALL_REQUEST(defaultParams));
    }, [ dispatch, defaultParams ]);

    useEffect(() => {
        if (intfile?.action === 'delete') {
            handleRefresh();
        }
    }, [intfile, handleRefresh]);
    

    const handleSearch = useCallback(
        (params) => {
            const searchParams = {
                ...params,
                pagesize: params.pagesize || defaultParams?.pagesize,
                pageno: params.pageno || defaultParams?.pageno,
                sort: params.sort || defaultParams?.sort,
                sortOrder: params.sortOrder || defaultParams?.sortOrder,
            };
            dispatch(appActions.INTOUTBOUNDFILE_GET_ALL_REQUEST(searchParams));
        },
        [dispatch, defaultParams]
    );

    useEffect(() => {
        handleSearch(defaultParams);
    }, []); // Empty dependency array ensures it runs only on mount

    const linkToNew = useCallback(
        () => navigate('/ui/int-outbound-file/detail', { replace: false }),
        [navigate],
    );

    // const handleViewRedirect = useCallback(
    //     (record) => {
    //         const data = intFileList?.data?.find(t => t.id === record.id);
    //         navigate('/ui/int-outbound-file/detail', { state: { data, isView: true } });
    //     },
    //     [intFileList, navigate]
    // );
    const renderHeader = () => {
        return (
            <div className="d-flex flex-row gap-10 align-items-center">
                <h1 className="page-header flex">Integration Outbound File </h1>
                <Button icon="pi pi-sync" rounded text aria-label="Refresh" className='mr-auto tp'  data-pr-tooltip="Refresh" onClick={handleRefresh} />
                <Button label="Add New" icon="pi pi-plus" className="p-button-outlined tp" data-pr-tooltip="Add New" onClick={linkToNew} />
            </div>
        );
    };

    const actionTemplate = useCallback(
        (rowData) => {
            const data = intFileList?.data?.find(t => t.id === rowData.id);
            return (
                <div className="flex gap-10 justify-content-center">
                    <span className="cursor-pointer tp" onClick={() => navigate('/ui/int-outbound-file/detail', { state: { data, isView: true } })} data-pr-tooltip="View">
                        <i className="pi pi-eye text-blue-500 text-base"></i>
                    </span>
                </div>
            );
        },
        [intFileList, navigate]
    );

    const onFilterChangeCallback  = useCallback(
        (e) => {

            const { sortField, sortOrder, rows, page } = e;
            
            const params = {...formValues, pagesize: rows, pageno: page, sort: sortField, sortOrder: sortOrder };

            setFormValues(prevFormValues => ({
                ...prevFormValues,
                sort: sortField, 
                sortOrder: sortOrder,
                pagesize: rows,
                pageno: page
            }));

            handleSearch(params); // Call search with updated sorting params
        },
        [handleSearch, formValues],
    );
 
    const columns = [
        { field: 'fileId', header: 'File Id', sortable: true, fileLog: true, width: '80px' },
        { field: 'fileType', header: 'File Type', sortable: true, fileLog: true, width: '100px'  },
        { field: 'storeId', header: 'Store Id', sortable: true, width: '80px' },
        { field: 'businessDate', header: 'Business Date', sortable: true},
        // { field: 'beginDateTime', header: 'Begin DateTime', sortable: true, width: '90px' },
        // { field: 'endDateTime', header: 'End DateTime', sortable: true, width: '90px' },
        { field: 'inFilePath', header: 'In File Path', sortable: true,  },
        { field: 'outFilePath', header: 'Out File Path', sortable: true,},
        { field: 'xmlStatus', header: 'Xml Status', sortable: true, width: '120px' },
        { field: 'error', header: 'Error', sortable: true, width: '100px' },
        { field: 'logText', header: 'Log Text', sortable: true, maxWidth: "100px" },
        { field: 'status', header: 'Status', sortable: true, width: '100px' },
        { field: 'createdOn', header: 'Created On', sortable: true, width: '140px', columnType: 'datetime' },
        // { field: 'lastUpdated', header: 'Last Updated', sortable: true, columnType : 'datetime' },
        // { field: 'lastUpdatedBy', header: 'Last Updated By', sortable: true },
    ];

    const renderList = () => {
        return (
            <>
                <div className='pv-15 ph-15'> {renderHeader()} </div>
                <div className="bg-white mx-3 pv-15 ph-15 br-6 shadow-white">
                    <IntOutBoundFileFilterForm 
                        handleSearch={handleSearch} 
                        handleReset={handleReset}  
                        onFormValuesChange={handleFormValuesChange} 
                    />
                    <div className='custom-devider'></div>
                    <PrimeTable
                        list={intFileList}
                        columns={columns}
                        actionColumn={actionTemplate}
                        onFilterChangeCallback={(e) => {
                            onFilterChangeCallback(e);
                        }}
                        tableName='integration_file'
                        isLazy={true}
                        showGenerateXmlBtn={false}
                    />
                </div>
            </>
        );
    };

    return <div className="form_height">{renderList()}</div>;
};


export default IntOutBoundFileList;
